// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","cardFeedHighlight":"_3H4HR0AVYvtNUX5Fk5kp-S"};